import React, { FC } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider } from 'wagmi'
import { RainbowKitProvider } from '@rainbow-me/rainbowkit'; 
import '@rainbow-me/rainbowkit/styles.css';
import * as GetWagmiConfig from './GetWagmiConfig';
// import EagerConnectWrapper from './EagerConnectWrapper';

interface MyComponentProps {
  inside: JSX.Element;
  currencyID: number;
  chains: any
}

const queryClient = new QueryClient();

const App1: FC<MyComponentProps> = ({ inside, currencyID, chains }) => {

  const wagmiConfig = GetWagmiConfig.getWagmiConfig(currencyID, chains);


  return <WagmiProvider config={wagmiConfig}> <QueryClientProvider client={queryClient}> <RainbowKitProvider> {inside} </RainbowKitProvider>
    </QueryClientProvider></WagmiProvider>

  }

  

export default App1;

